import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { Utility } from "../../common/utility";
import { BaseUrl } from "../../shared/urls/base.url";
import { AppConstants } from "../../shared/constants/constants";
import { AuthService } from "../../shared/services/auth.service";
import { AuthHelper } from "../../common/auth.helper";
import { DialogService } from "../../shared/services/dialog.service";
import { AppMessages } from "../../shared/constants/messages";

@Component({
  selector: "app-landing",
  templateUrl: "./landing.component.html",
})
export class LandingComponent implements OnInit {
  appConstants = AppConstants;
  navigateUrl: string = "/request-appointment";
  authConfig = BaseUrl.AUTH_CONFIG;
  href: string;
  isShowLogin = false;
  isShowRegister = false;
  userName: string;

  constructor(
    private router: Router,
    private activeRouter: ActivatedRoute,
    private authService: AuthService,
    public dialogService: DialogService
  ) {}

  ngOnInit() {
    this.activeRouter.paramMap.subscribe((params) => {
      this.userName = params.get("username");
      let subscribedParam = params.get("action");
      if (subscribedParam === "login") {
        this.login();
      } else if (subscribedParam === "register") {
        this.isShowRegister = true;
      } else {
        this.isShowLogin = true;
        this.isShowRegister = true;
      }
    });
  }

  public login() {
    AuthHelper.resetLocalStorage();
    if (this.userName) {
      this.router.navigate(["/login", this.userName]);
      return;
    }

    this.router.navigate(["/login"]);
  }

  register() {
    this.dialogService
      .openConfirmationDialog({ message: AppMessages.landing.confirmMessage })
      .subscribe((confirm) => {
        if (confirm == true) {
          this.login();
        } else if (confirm == false) {
          this.router.navigate(["/register"]);
        }
      });
  }
}



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/pages/landing/landing.component.ts